














































import { Component, Vue, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AgencyModule } from '@/store/modules/agency';
import UpdateRichTextRequest from '@/models/Shared/UpdateRichTextRequest';
import AgencyDto from '@/models/Agencies/AgencyDto';
import { AgencySettingsModule } from '@/store/modules/agencySettings';

@Component({
    name: 'AgencyGeneralTrainingInformationEdit'
})
export default class AgencyGeneralTrainingInformationEdit extends GiganautVueDialog {

  entity: AgencyDto = new AgencyDto();
  public editorKey = 0;
  public editorReady = false;

  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.editorReady = false;
      this.entity = JSON.parse(JSON.stringify(AgencySettingsModule.agency));
      this.editorKey++;
      this.$nextTick(() => {
        this.editorReady = true;
      });
    } else {
      this.editorReady = false;
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    
    const request = new UpdateRichTextRequest();
    request.updatedAt = this.entity.updatedAt;
    request.richText = this.entity.generalTrainingInformation;

    await AgencySettingsModule.editAgencyGeneralTrainingInformation(request)
    this.dialog = false;
  }
}
